<div class="pb-6 px-5 lg:px-8 xl:px-12">
  <div
    class="lg:hidden my-3 mix-blend-multiply"
    *ngIf="displayAddressSearchInput"
  >
    <app-shop-search-location-input></app-shop-search-location-input>
  </div>
  <div class="flex items-center lg:justify-between">
    <div
      *ngIf="this.displayTitle"
      class="hidden lg:block"
    >
      <h2 class="font-accent font-bold text-4.5xl text-neutral-800">
        {{ title | translate }}
      </h2>
    </div>
    <div class="flex items-center">
      <app-button-atom
        *ngIf="displayFiltersButton"
        [icon]="'icon-filter'"
        [size]="'S'"
        [type]="'light'"
        [label]="
          (nbFilters$ | async)
            ? ('shop-list-header.filter' | translate) + ' (' + (nbFilters$ | async) + ')'
            : ('shop-list-header.filter' | translate)
        "
        [color]="'primary'"
        class="mr-2"
        (clickEventEmitter)="openFilters()"
      ></app-button-atom>
      <app-button-atom
        *ngIf="displayMapButton"
        class="hidden lg:block ml-2"
        [type]="'primary'"
        [icon]="'icon-distance'"
        [size]="'S'"
        [color]="'primary'"
        [overrideBgColor]="shopsMapButtonColor"
        [overrideTextColor]="shopsMapButtonTextColor"
        [label]="'shop-list-header.show-map' | translate"
        (clickEventEmitter)="navigateToMapPage()"
      ></app-button-atom>
    </div>
  </div>
  <div>
    <ng-container *ngIf="selectedFilters$ | async as filters">
      <div
        *ngIf="filters.length"
        class="mt-6"
      >
        <div
          class="inline-block"
          *ngFor="let filterValues of filters"
        >
          <div
            class="inline-block mr-3 mb-3"
            *ngFor="let filter of filterValues.values"
          >
            <app-chip-atom
              [label]="filter.label"
              [value]="filter.value"
              [id]="filterValues.id"
              (removeChip)="removeFilter($event)"
            ></app-chip-atom>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedCategories$ | async as categories">
      <div
        *ngIf="categories.length"
        class="mt-6"
      >
        <div
          class="inline-block mr-3 mb-3"
          *ngFor="let category of categories"
        >
          <app-chip-atom
            [label]="category.name"
            [value]="category"
            [id]="category.id"
            (removeChip)="removeCategoryFilter($event)"
          ></app-chip-atom>
        </div>
      </div>
    </ng-container>
  </div>
</div>
